<div class="porHeader wrapper por-ac-header" [ngStyle]="{ width: width, height: height }" [ngClass]="{ 'quick-link': appFacadeService.versionToggleService.isQLButNotConsumerQL() }">
    <div class="header-logo-wrapper">
        @if ( isMobile && appFacadeService.versionToggleService.isAdvanceVersion() && appFacadeService.versionToggleService.isNotQLOrConsumerQL() && (appFacadeService.isPaymentSectionEnabled() |
        async) === false ) {
        <div class="hamburger-header mobile-menu-show">
            <ng-container>
                <por-hamburger icon="view_headline" panelClass="mobile-nav-items" [closeOnPanel]="true" [logo]="logo" classes="menu-hamburger">
                    <ul>
                        @for (item of hamburgerItems; track item) {
                        <li
                            class="theme-list-item nav-items"
                            [ngClass]="{
                                active: (appFacadeService.getActiveTab() | async) === item?.page
                            }"
                            (click)="changePage(item.page)">
                            <a class="toggle-sectnav">
                                <span>{{ item.label | translate }}</span>
                            </a>
                        </li>
                        }
                    </ul>
                </por-hamburger>
            </ng-container>
        </div>
        }

        <a
            href="javascript:void(0)"
            class="logo"
            (click)="setHomePageTab()"
            [ngClass]="{
                'logo-left': header?.logoPosition === 'left',
                'logo-right': header?.logoPosition === 'right',
                'logo-center': header?.logoPosition === 'center',
                'title-right': header?.headerTitlePosition === 'right',
                'title-left': header?.headerTitlePosition === 'left',
                'title-center': header?.headerTitlePosition === 'center',
                'depot-wrapper': logo === '',
                'payment-enabled': (appFacadeService.isPaymentSectionEnabled() | async)
            }"
            porAddFeature
            featureName="logo">
            @if (showHeaderSection()) { @if (isLogoDisplayed()) {
            <img [ngStyle]="{ width: logoWidth }" class="header-logo" [src]="logo" />
            } @else {
            <span class="depot-name">{{ header?.depotName }}</span>
            } } @if (title) {
            <span>
                {{ title }}
            </span>
            }
        </a>
    </div>

    @if (appFacadeService.versionToggleService.isAdvanceVersion() && appFacadeService.versionToggleService.isNotQLOrConsumerQL()) {
    <por-page-sidebar [config]="config"></por-page-sidebar>
    } @if (showHeaderSection() && (!isMobile || (appFacadeService.isPaymentSectionEnabled() | async) === false)) {
    <div class="profile-hamburger">
        @if (appFacadeService.versionToggleService.isNotQLOrConsumerQL()) {
        <por-hamburger icon="person" btnimg="{{ uiUrl }}/assets/images/CP_Profile icon_ final.svg" classes="person-hamburger" porAddFeature featureName="profile-button">
            <ul>
                <span class="username">{{ customer?.Name }}</span>
                <ng-template porFeatureAvailability [featureToken]="['logOff']">
                    <li (click)="logout.emit()">
                        <a porAddFeature featureName="logout-button">
                            <mat-icon>logout</mat-icon>
                            <span>{{ 'Logout' | translate }}</span>
                        </a>
                    </li>
                </ng-template>
                <li class="lang-select-wrapper">
                    <por-language-selector (selectedLocale)="handleSelectedLocale($event)" [options]="languageOptions" [selectedLanguageOption]="selectedLanguageOption"></por-language-selector>
                </li>
                @if (false) { @if (appFacadeService.isAccountFeaturesLoaded() | async) {
                <ng-template porFeatureAvailability [featureToken]="['Account.Admin']">
                    <li (click)="viewContacts()" class="nav-items">
                        <a porAddFeature featureName="manage-users">
                            <mat-icon>open_in_new</mat-icon>
                            <span>{{ 'ManageUsers' | translate }}</span>
                        </a>
                    </li>
                </ng-template>
                } @else {
                <span porIcon icon="spinner" class="spinner position-relative"></span>
                } }
            </ul>
        </por-hamburger>
        } @if (showLoginMoreInfoButton()) {
        <por-hamburger
            icon="view_headline"
            panelClass="mobile-nav-items"
            icon="person"
            btnimg="{{ uiUrl }}/assets/images/CP_Profile icon_ final.svg"
            classes="person-hamburger"
            porAddFeature
            featureName="profile-button"
            (click)="openModal()">
            @if (visible) {
            <div class="menu-inner">
                <span class="cross-icon" (click)="onClose()">X</span>
                <ng-template porFeatureAvailability [featureToken]="['multiplePaymentAbility']" [fallbackTemplate]="quickInfoTitle">
                    <h2>{{ 'QuickInfoForMultiplePayment' | translate }}</h2>
                </ng-template>
                <ng-template #quickInfoTitle>
                    <h2>{{ 'QuickInfo' | translate }}</h2>
                </ng-template>
                <por-base-button featureName="login-page" [theme]="'primary'" (click)="openConsumerPortal()">
                    {{ 'LoginMoreContracts' | translate }}
                </por-base-button>
                <div class="list">
                    <div class="list-title">{{ 'ThisNeeded' | translate }}:</div>
                    <ul>
                        <li>{{ 'SingleContract' | translate }}</li>
                        <ng-template porFeatureAvailability [featureToken]="['secureUrlLoginRequired']" [fallbackTemplate]="showWhenNotAvailable"></ng-template>
                    </ul>
                    <ng-template #showWhenNotAvailable>
                        <li>{{ 'ViewPDF' | translate }}</li>
                        <li>{{ 'Esigndoc' | translate }}</li>
                    </ng-template>
                </div>
            </div>
            }
        </por-hamburger>
        }
    </div>
    }
</div>
